export default "__VITE_ASSET__6cf1908e__"